export default __webpack_public_path__ + "static/lvds-0a1a90ab58d8bc18730467e4943c5012.png";